export default __webpack_public_path__ + "static/media/io.0cd14b1f.svg";